import { render, staticRenderFns } from "./EditCartResource.vue?vue&type=template&id=16f8e72e&scoped=true"
import script from "./EditCartResource.vue?vue&type=script&lang=js"
export * from "./EditCartResource.vue?vue&type=script&lang=js"
import style0 from "./EditCartResource.vue?vue&type=style&index=0&id=16f8e72e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f8e72e",
  null
  
)

export default component.exports